import { languageSelector } from "@/src/contexts";
import type { IStepperItem, IStepperLine } from "@Components/Stepper";

import StepBasket from "@Assets/StepBasket.svg";
import StepCircleArrows from "@Assets/StepCircleArrows.svg";
import StepCoins from "@Assets/StepCoins.svg";
import StepGoodieLogo from "@Assets/StepGoodieLogo.svg";

import { CashbackMainPageResources } from "./CashbackMainPage.Resources";
import { CashbackMainPageResourcesEn } from "./CashbackMainPage.Resources.En";

interface IWhatIsCashbackResource {
    step1Title: string;
    step1Description: string;
    step2Title: string;
    step2Description: string;
    step3Title: string;
    step3Description: string;
    step4Title: string;
    step4Description: string;
}

const getLineInfo = (isMobile: boolean) => {
    if (isMobile) {
        return {
            height: "75%",
            width: "0",
        } as IStepperLine;
    }

    return {
        height: "0",
        width: "100%",
    } as IStepperLine;
};

const getResources = () =>
    languageSelector(
        CashbackMainPageResources.cashbackProcessSteps,
        CashbackMainPageResourcesEn.cashbackProcessSteps,
    );

const stepperSteps = (resourcesSteps: IWhatIsCashbackResource): IStepperItem[] => [
    {
        title: resourcesSteps.step1Title,
        description: resourcesSteps.step1Description,
        svgFile: StepGoodieLogo,
    },
    {
        title: resourcesSteps.step2Title,
        description: resourcesSteps.step2Description,
        svgFile: StepBasket,
    },
    {
        title: resourcesSteps.step3Title,
        description: resourcesSteps.step3Description,
        svgFile: StepCoins,
    },
    {
        title: resourcesSteps.step4Title,
        description: resourcesSteps.step4Description,
        svgFile: StepCircleArrows,
    },
];

export { getResources, stepperSteps, getLineInfo };
